import { Environment } from './environment.interface';

export const environment: Environment = {
  name: 'production',
  firebase: {
    projectId: 'accutrac-ac8ea',
    appId: '1:418733725319:web:9df88f464e102ea72c4a22',
    storageBucket: 'accutrac-ac8ea.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyCRg1H85LpsuUjYigXayLEQdgsFIxvuBT4',
    authDomain: 'accutrac-ac8ea.firebaseapp.com',
    messagingSenderId: '418733725319',
  },
  production: true,
  enableServiceWorker: true, // Enable service worker for production
  accutraxAPIKey: '82a1af75-7676-4ecc-9238-7dcffb1d65c7',
  apiUrl: 'https://accutrax.biz/api/',
};
